/*  ========================================================================
    # Scripts - Mobile Submenu
    ========================================================================  */

/**
 * Script that handles the accordion behaviour of submenus inside the mobile menu.
 */
const MobileSubmenu = {
  cfg: {
    toggles: document.querySelectorAll('.c-header__mobile-submenu-toggle'),
    classes: {
      item: 'c-header__mobile-menu-item',
      itemOpen: 'c-header__mobile-menu-item--open'
    }
  },

  /**
   * Toggle the submenu of a mobile menu item.
   */
  toggleItem(item, toggle) {
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    item.classList.toggle(this.cfg.classes.itemOpen);
    toggle.setAttribute('aria-expanded', !isExpanded);
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.toggles.length) {
      this.cfg.toggles.forEach(toggle => {
        const item = toggle.closest(`.${this.cfg.classes.item}`);

        toggle.addEventListener('click', () => {
          this.toggleItem(item, toggle);
        });
      });
    }
  }
};

export default MobileSubmenu;
